<template>
  <section class="loyalty">
    <BliLoaderSkeleton
      v-if="showLoyaltySectionLoader"
      class="section-loader"
    />
    <div
      v-else
      :class="['rewards-container', {'profile': isProfilePageRoute}]"
      @click="handleRewardActionClick"
    >
      <div class="title">
        {{ $t('appHeader.currentPoint') }}
      </div>
      <div class="rewards-detail">
        <BliIconSiPointsBlibli class="icon" />
        <div
          :class="['points', {'profile': isProfilePageRoute}]"
        >
          {{ enablePointsRetryOption ?
            $t('appHeader.pointsFailedToLoad')
            : (activePoints ? formattedActivePoints : $t('appHeader.noData') )
          }}
        </div>
        <BliIconSiChevronRight class="action" />
      </div>
    </div>
    <BliLoaderSkeleton
      v-if="showLoyaltySectionLoader"
      class="section-loader"
    />
    <div
      v-else
      :class="['mission-container', {'profile': isProfilePageRoute}]"
      @click="handleMissionActionClick"
    >
      <div class="title">
        {{ $t('appHeader.ongoingMission') }}
      </div>
      <div class="mission-detail">
        <BliIconSiCircleTierDiamond class="icon" />
        <div
          :class="['name', {'profile': isProfilePageRoute}]"
        >
          {{ activeMissionCount ? activeMissionCount : $t('appHeader.noData') }}
        </div>
        <BliIconSiChevronRight class="action" />
      </div>
    </div>
    <div
      :class="['credit-note-container', {'profile': isProfilePageRoute}]"
      @click="handleCreditNoteActionClick"
    >
      <div class="title">
        {{ $t('appHeader.creditNote') }}
      </div>
      <div class="credit-note-detail">
        <img
          src="@vue3/assets/icons/credit-note.svg"
          class="icon"
          alt="ikon"
        >
        <BliLoaderSkeleton
          v-if="isCountFetching"
          height="18px"
          class="credit-note-loader"
        />
        <div
          v-else
          :class="['value', {'profile': isProfilePageRoute}]"
        >
          {{ isCreditNoteCountError ? $t('appHeader.pointsFailedToLoad') : creditNoteCount }}
        </div>
        <BliIconSiChevronRight class="action" />
      </div>
    </div>
  </section>
</template>
<script src="./index.js" />
<style lang="scss" scoped>
@import "@vue3/assets/styles/_responsive.scss";
@import '@blibli/blue-design-tokens/dist/tokens-default.scss';
html:not([dark]) {
      @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
      @import './index.scss';
    }
    html[dark] {
      @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
      @import './index.scss';
    }
</style>

